import { Injectable } from "@angular/core";
@Injectable({
  providedIn: 'root' 
})
export class AppConfig {
    public hubUrl: string;
    public timeoutInSeconds: string;
    public gatewayKey: string;

}
// app.config.ts
import { ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(), // Required for Angular Material components
        // Add other providers here
    ]
};